import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import './setup/i18n/i18n';
import { LoadingPage } from './Components';

// Lazy load all page components
const Home = lazy(() => import('./pages/home/Home'));
const About = lazy(() => import('./pages/about/About'));
const CoursesList = lazy(() => import('./pages/courses/List/List'));
const CoursesDetail = lazy(() => import('./pages/courses/Detail/Detail'));

// Lazy load service pages
const ASD = lazy(() => import('./pages/services/ASD'));
const REOC = lazy(() => import('./pages/services/REOC'));
const SCEC = lazy(() => import('./pages/services/SCEC'));
const FSEB = lazy(() => import('./pages/services/FSEB'));
const CRM = lazy(() => import('./pages/services/CRM'));

// Lazy load components
const Layout = lazy(() => import('./layouts/Layout/Layout'));
const Page404 = lazy(() => import('src/Components/Page404/Page404'));



function App() {
	return (
		<Suspense fallback={<LoadingPage />}>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<Home />} />
					<Route path='about' element={<About />} />
					<Route path='serivces'>
						<Route path='accounting-and-systems-design-services' element={<ASD />} />
						<Route path='review-and-evaluation-of-companies' element={<REOC />} />
						<Route path='studies-consultations-establishing-companies' element={<SCEC />} />
						<Route path='feasibility-studies-and-estimated-budgets' element={<FSEB />} />
						<Route path='customer-relationship-management' element={<CRM />} />
					</Route>
					<Route path='courses/'>
						<Route index element={<CoursesList />} />
						<Route path=':id' element={<CoursesDetail />} />
					</Route>
					<Route path="*" element={<Page404 />} />
				</Route>
			</Routes>
		</Suspense>
	);
}

export default App;
